/**
 * 静态网络图片统一配置
 *
 * 所有项目中使用的静态网络图片 URL 均在此集中管理，便于统一修改和维护。
 * 分为两个 CDN 源：
 * - STATIC_URL：应用静态资源 CDN（环境变量 VITE_APP_STATICURL 控制）
 * - ADMIN_IMG_BASE：管理后台图片上传 CDN
 */

/** 静态资源 CDN 基础地址（由环境变量注入，各站点可能不同） */
export const STATIC_URL = import.meta.env.VITE_APP_STATICURL;

/** 管理后台图片上传 CDN 基础地址 */
export const ADMIN_IMG_BASE = 'https://img.goooy.cn/image/admin';

// ============================================================
//  文件类型图标（/static/icons/）
// ============================================================

export const FILE_TYPE_ICONS: Record<string, string> = {
  avi: `${ADMIN_IMG_BASE}/20260718/fa65d90c2b1e39e76c968920db7ae629.png`,
  css: `${ADMIN_IMG_BASE}/20260718/d54c0206b88e4c90a7075c5d7f71eb4a.png`,
  csv: `${ADMIN_IMG_BASE}/20260718/c31fccedec269ad6640fa2c80be97a5c.png`,
  doc: `${ADMIN_IMG_BASE}/20260718/e1c07b9918cebeb30610592372a406e8.png`,
  eml: `${ADMIN_IMG_BASE}/20260718/5acb98ade6d6d954ec9fcd87051dd80b.png`,
  eps: `${ADMIN_IMG_BASE}/20260718/798af99120cb5ba4a2255d974e518a17.png`,
  html: `${ADMIN_IMG_BASE}/20260718/f8498d71a0df7a8bd5a0e3e7c04c4000.png`,
  jpg: `${ADMIN_IMG_BASE}/20260718/b5c5ff807bfab3ff82c3d2fd99b5a633.png`,
  mov: `${ADMIN_IMG_BASE}/20260718/4d0effef648c9d0fb447b89ef0126113.png`,
  mp3: `${ADMIN_IMG_BASE}/20260718/81c59fe1069f8cfbf0806c76d9d69d88.png`,
  pdf: `${ADMIN_IMG_BASE}/20260718/3e21ea2433364b29114b3f36028ba5d3.png`,
  png: `${ADMIN_IMG_BASE}/20260718/7292b0a75895d59e3a5803f5f4bed7fb.png`,
  ppt: `${ADMIN_IMG_BASE}/20260718/748ff1071b3cf44bd8ceb3feade63af5.png`,
  rar: `${ADMIN_IMG_BASE}/20260718/b6e08631bcb15a6c3580979c89b00433.png`,
  raw: `${ADMIN_IMG_BASE}/20260718/bf8c6533c4398c495ae12d069501af12.png`,
  ttf: `${ADMIN_IMG_BASE}/20260718/cf65bf37ad444ece838c9d4ca321a93f.png`,
  txt: `${ADMIN_IMG_BASE}/20260718/df2b4f598df877aae32810bcc1a2d85e.png`,
  wav: `${ADMIN_IMG_BASE}/20260718/8cae8351743467e0369d13b500466857.png`,
  xls: `${ADMIN_IMG_BASE}/20260718/2b7900b5bb21d13646c2fdc052e09240.png`,
  zip: `${ADMIN_IMG_BASE}/20260718/715675a077f6855813ab02af6d60e3cf.png`,
  video: `${ADMIN_IMG_BASE}/20260718/915ff332b8fa10bf075c0ef010676bf9.png`,
};

// ============================================================
//  平台图标（/52dsy/static/platform/）
// ============================================================

/** 平台图标（按平台ID映射） */
export const PLATFORM_ICON_MAP: Record<number, string> = {
  1: `${ADMIN_IMG_BASE}/20260718/6237de80e17d8c34ae4dcca9febc54c0.png`, // 拼多多
  2: `${ADMIN_IMG_BASE}/20260718/201bf4d34ce30305d766c3ffd1921bcc.png`, // 淘宝
  3: `${ADMIN_IMG_BASE}/20260718/3c62219314c7fdc9058b48cba04cff4f.png`, // 京东
  4: `${ADMIN_IMG_BASE}/20260718/d0ef66a74f708a462b123a7a198d7c9d.png`, // 抖音
  5: `${ADMIN_IMG_BASE}/20260718/f3b8a10522eb4981d49fa92a79270c05.png`, // 虾皮
  6: `${ADMIN_IMG_BASE}/20260718/6f275d710143f1296f9f8a688b0efe6b.png`, // 小红书
  7: `${ADMIN_IMG_BASE}/20260718/8a8729ce48d16ba86fac40e893d0fe3c.png`, // 快手
  9: `${ADMIN_IMG_BASE}/20260718/9bc77d40133cb97eb97aaa3d0422f301.png`, // 1688
  12: `${ADMIN_IMG_BASE}/20260718/53b7307e4dbc7b606a73438052b0438a.png`, // 微信小店
  13: `${ADMIN_IMG_BASE}/20260718/a53bf37f729d3407981d12ca0e3aedc0.png`, // Tiktok
  15: `${ADMIN_IMG_BASE}/20260718/c47b45f5d6a183005e8e249cb9d3c2e7.png`, // HKTVmall
  16: `${ADMIN_IMG_BASE}/20260718/d82bacae29fa814b63f3ebde895f1b0e.png`, // 得物
  18: `${ADMIN_IMG_BASE}/20260718/84402aa577a10da454631fdf7c1773de.png`, // Lazada
  20: `${ADMIN_IMG_BASE}/20260718/f9c2c176e8e9b9cd274213be94e76232.png`, // 速卖通
};

/** 平台图标（按名称映射，用于 UploadPlatformPopup 等场景） */
export const PLATFORM_ICONS = {
  pdd: `${ADMIN_IMG_BASE}/20260718/6237de80e17d8c34ae4dcca9febc54c0.png`,
  tb: `${ADMIN_IMG_BASE}/20260718/201bf4d34ce30305d766c3ffd1921bcc.png`,
  jd: `${ADMIN_IMG_BASE}/20260718/3c62219314c7fdc9058b48cba04cff4f.png`,
  dy: `${ADMIN_IMG_BASE}/20260718/d0ef66a74f708a462b123a7a198d7c9d.png`,
  shopee: `${ADMIN_IMG_BASE}/20260718/f3b8a10522eb4981d49fa92a79270c05.png`,
  xhs: `${ADMIN_IMG_BASE}/20260718/6f275d710143f1296f9f8a688b0efe6b.png`,
  ks: `${ADMIN_IMG_BASE}/20260718/8a8729ce48d16ba86fac40e893d0fe3c.png`,
  1688: `${ADMIN_IMG_BASE}/20260718/9bc77d40133cb97eb97aaa3d0422f301.png`,
  wxsph: `${ADMIN_IMG_BASE}/20260718/53b7307e4dbc7b606a73438052b0438a.png`,
  tiktok: `${ADMIN_IMG_BASE}/20260718/a53bf37f729d3407981d12ca0e3aedc0.png`,
  hktvmall: `${ADMIN_IMG_BASE}/20260718/c47b45f5d6a183005e8e249cb9d3c2e7.png`, // HKTVmall
  dewu: `${ADMIN_IMG_BASE}/20260718/d82bacae29fa814b63f3ebde895f1b0e.png`, // 得物
  lazada: `${ADMIN_IMG_BASE}/20260718/84402aa577a10da454631fdf7c1773de.png`, // Lazada
  aliExpress: `${ADMIN_IMG_BASE}/20260718/f9c2c176e8e9b9cd274213be94e76232.png`, // 速卖通
};

// ============================================================
//  支付方式图标（/52dsy/static/）
// ============================================================

export const PAYMENT_ICONS = {
  balance: `${ADMIN_IMG_BASE}/20260718/83ab0961bf8692083515c16d8a545788.png`,
  alipay: `${ADMIN_IMG_BASE}/20260718/9d2b2145dd3dbe8309c745abfb893511.png`,
  wechat: `${ADMIN_IMG_BASE}/20260718/433c5d3bfb9e4809a6b787fd5e78b2bc.png`,
};

// ============================================================
//  站点商务合作图片（/site/）
// ============================================================

export const SITE_IMAGES = {
  /** 揭阳站 - 商务合作 / 五二摄影 / 五二财税 */
  sellerCooperate: `${STATIC_URL}/site/seller_cooperate.jpg`,
  /** 揭阳站 - 档口入驻 */
  wwwPifa: `${STATIC_URL}/site/www_pifa.jpg`,
  /** 普宁站 - 商务合作 / 档口入驻 */
  pnPifa: `${STATIC_URL}/site/pn_pifa.jpg`,
  /** 新塘站 - 商务合作 / 档口入驻 */
  xtPifa: `${STATIC_URL}/site/xt_pifa.jpg`,
  /** 沙河站 - 商务合作 / 档口入驻 */
  shPifa: `${STATIC_URL}/site/sh_pifa.jpg`,
};

// ============================================================
//  订单配置说明图片（/static/mobile/）
// ============================================================

export const ORDER_CONFIG_IMAGES = {
  /** 多件有货先发说明图 */
  lotHave: `${ADMIN_IMG_BASE}/20260718/6e88181fc8981d34fb94098a62c32e78.png`,
  /** 评价有礼说明图 */
  appWithCourt: `${ADMIN_IMG_BASE}/20260718/dd8ecf335d7e70d0a63adcf355f8477b.png`,
};

// ============================================================
//  通用杂项图片
// ============================================================

/** 占位头像 */
export const PLACEHOLDER_USER_AVATAR = `${ADMIN_IMG_BASE}/20260718/969c40044dccc19f7bd3487b962bd6d3.png`;

/** 商品详情代发说明图 */
export const GOODS_EXPLAIN_IMAGE = `${ADMIN_IMG_BASE}/20260718/ef5e42986f6f439ecee3ed9b057c4de3.png`;

/** 年费档口背景图 */
export const ANNUAL_FEE_BG = `${ADMIN_IMG_BASE}/20260718/0b47faaec245345b20c5042ffad53ede.png`;

/** 年费档口角标 */
export const ANNUAL_FEE_ACT = `${ADMIN_IMG_BASE}/20260718/ca343cded25122945bfa9598014ae1fb.png`;

/** 商品卡片广告位 HOT 丝带角标（与 dsy-home 皮肤目录同一素材） */
export const GOODS_HOT_TAG = 'https://sta.ios.goooy.cn/goods/skins3/hot.png';

/** 工厂档口头像金框（与年费档口角标同图，档口头像装饰框） */
export const FACTORY_GOLD_BADGE = `${ADMIN_IMG_BASE}/20260718/ca343cded25122945bfa9598014ae1fb.png`;

/** 素材空间文件夹图标 */
export const FOLDER_ICON = `${ADMIN_IMG_BASE}/20260718/607feb45fa80f5f9abe659a4b47a9514.png`;

/** 收藏列表置顶角标 */
export const COLLECT_TOP_ICON = `${ADMIN_IMG_BASE}/20260718/09d820d4939ac1fbdfe7ab51b2cbed24.png`;

/**
 * 商品卡片店铺等级图标（索引 0-3 对应店铺等级 scopeLv）
 * - 索引 0：普通店铺图标（原 shop_icon.png）
 * - 索引 1-3：店铺等级图标（原 shop_level_1/2/3.png）
 */
export const SHOP_LEVEL_ICONS = [
  `${ADMIN_IMG_BASE}/20260723/de653202f9eb413d29f049ce2a38e812.png`, // 普通店铺
  `${ADMIN_IMG_BASE}/20260723/d97b61de689e24c592eb49a2ccb45418.png`, // 等级 1
  `${ADMIN_IMG_BASE}/20260723/29e35d3b3169dad307c18dc65ecbc4c5.png`, // 等级 2
  `${ADMIN_IMG_BASE}/20260723/c13fc8d18b1bd962a6afa09a1e0d7774.png`, // 等级 3
];

/** 商务合作页头部 Banner */
export const BUSINESS_HEADER_IMG = `${STATIC_URL}/index/img/de25d012f2953cb8d82de3504c0b4f63.png`;

/** 通知提示音 */
export const NOTIFICATION_SOUND = `${STATIC_URL}/seller/static/source/newsMessage.wav`;

/** 积分规则页 */
export const RULE_HTML_URL = `${STATIC_URL}/rule.html`;

/** APP下载页静态资源基础路径 */
export const APP_DOWNLOAD_BASE = `${STATIC_URL}/newHome/appdown`;

/** 客服聊天默认头像 */
export const CHAT_AVATARS = {
  talk: `${ADMIN_IMG_BASE}/20260718/0afea2d603b244655311aab148cf4b33.jpg`,
  userPic: `${ADMIN_IMG_BASE}/20260718/4542ab9d8b371796e1d854d4957d2aff.jpg`,
  ticket: `${ADMIN_IMG_BASE}/20260718/58ba374a44eb795628e4501d3526d054.jpg`,
  mh: `${ADMIN_IMG_BASE}/20260718/2b263506a1b562e35b1da46efa2f4d3d.jpg`,
  channel: `${ADMIN_IMG_BASE}/20260718/3fb520bee9c8e5439cbad9eb6a8ac0f9.jpg`,
  msg: `${ADMIN_IMG_BASE}/20260718/41d29818f97b0245ffefcae5714037e0.jpg`,
  robot: `${ADMIN_IMG_BASE}/20260718/7ac33a046bbbcbb78992cbf31d87793c.jpg`,
  site: `${ADMIN_IMG_BASE}/20260718/c078451cf7668866ea6b425154dbceea.jpg`,
};

/** 档口积分页 - 财税咨询二维码 */
export const TAX_CODE_IMAGE = `${STATIC_URL}/static/taxcode.jpg`;

/** 站点首页静态资源基础路径 */
export const SITE_STATIC_BASE = `${STATIC_URL}/52dsy/static`;

// ============================================================
//  管理后台图片（img.goooy.cn）
// ============================================================

/** 通知页顶部快捷菜单图标 */
export const NOTICE_TOP_ICONS = {
  platform: `${ADMIN_IMG_BASE}/20260716/e994bab0d4518054fb59334eccc1332f.png`, // 平台公告
  activity: `${ADMIN_IMG_BASE}/20260716/cd5f767dcbf57a3d34ea2d5f5af7cf7d.png`, // 活动消息
  service: `${ADMIN_IMG_BASE}/20260716/fe7cf44c0d6100c688c9c483a941be4f.png`, // 官方客服
};

/** 通知页消息列表图标 */
export const NOTICE_LIST_ICONS = {
  tutorial: `${ADMIN_IMG_BASE}/20260716/c5dd8523437bd2efca353df78e5c1689.png`, // 教程中心
  problem: `${ADMIN_IMG_BASE}/20260716/6cc30e4b4aa435496c09bdc75b69f376.png`, // 常见问题
  returns: `${ADMIN_IMG_BASE}/20260716/faf317a5b6dc673a9fd43b7103e5fd49.png`, // 退货指南
  business: `${ADMIN_IMG_BASE}/20260716/96ca6e79c481ec425546b0f67254c006.png`, // 商务合作
  siteMsg: `${ADMIN_IMG_BASE}/20260716/be466fc61c945a78c7b24f05edc9bdd2.png`, // 站内消息
  userNotice: `${ADMIN_IMG_BASE}/20260716/b16a151f0e44d6888675cf2239ef55db.png`, // 用户通知
};

/** 档口排行榜头部背景 */
export const RANK_HEADER_BG = `${ADMIN_IMG_BASE}/20260718/76b47f06102a93652761a1bf223cbcd2.png`;

/** 排行榜奖牌图标（第 1-4 名 podium 背景） */
export const RANK_MEDAL_ICONS = {
  rank1: `${ADMIN_IMG_BASE}/20260718/2e8f215e5633d5c6ebe59c490cef22e1.png`,
  rank2: `${ADMIN_IMG_BASE}/20260718/23047e649dffa4f7184d47d46d584d8c.png`,
  rank3: `${ADMIN_IMG_BASE}/20260718/0f2511c77f98ae9e98037a181754ad54.png`,
  rankBg: `${ADMIN_IMG_BASE}/20260718/82a2076da08a92c3c3297fce3744eae4.png`,
};

/** 排行榜代理站样式背景 */
export const SHOP_RANK_NICE_BG = `${STATIC_URL}/52dsy/static/niceBg.png`;

/**
 * 排行榜代理站排名图标（索引 0-2 对应 1-3 名）
 * 使用方式: `${STATIC_URL}/52dsy/static/shop_rank_${index + 1}.png`
 */
export const SHOP_RANK_ICON_BASE = `${STATIC_URL}/52dsy/static/shop_rank_`;
